module.exports = __webpack_public_path__ + "img/honor_005.56da984.png";